import K from "utilities/constants";
import { stringSorting } from "utilities/tableUtility";
import { Flex } from "common/components/flex/flex";
import { StatusTag } from "common/components/statusTag/statusTag";
import { DefaultColumnOptions } from "hooks/useDataGrid/options";
import { checkNullPlaceHolder } from "utilities/generalUtility";

const candidateNameTooltip = (params) => (
  <div className="client-list-tooltip">
    {`${params.data.candidate?.firstName} ${params.data.candidate?.lastName}`}
  </div>
);
const candidateTypeTooltip = (params) => (
  <div className="client-list-tooltip">
    {checkNullPlaceHolder(K.CandidateType[params.value])}
  </div>
);
const statusTooltip = (params) => (
  <div className="client-list-tooltip">{params.data.status.name}</div>
);
const subStatusToolip = (params) => (
  <div className="client-list-tooltip">{params.data.subStatus?.name}</div>
);

export const getColumns = () => [
  { ...DefaultColumnOptions.Id, sort: "asc" },
  {
    headerName: "Name",
    field: "candidate.firstName",
    sortable: true,
    tooltipField: "candidate.firstName",
    tooltipComponent: candidateNameTooltip,
    getQuickFilterText: (params) => {
      return [
        params.data.candidate?.firstName,
        params.data.candidate?.lastName,
      ].join(" ");
    },
    cellRenderer: (params) => (
      <div>
        {[
          params.data.candidate?.firstName,
          params.data.candidate?.lastName,
        ].join(" ")}
      </div>
    ),
  },
  {
    headerName: "Email",
    field: "candidate.email",
    sortable: true,
    tooltipField: "candidate.email",
  },
  {
    headerName: "Mobile Number",
    field: "candidate.mobileNumber",
    sortable: true,
    tooltipField: "candidate.mobileNumber",
    getQuickFilterText: (params) => params.value,
    cellRenderer: (params) => checkNullPlaceHolder(params.value),
  },
  {
    headerName: "Candidate Type",
    field: "hireType",
    sortable: true,
    tooltipField: "hireType",
    getQuickFilterText: (params) => K.CandidateType[params.value],
    cellRenderer: (params) =>
      checkNullPlaceHolder(K.CandidateType[params.value]),
    tooltipComponent: candidateTypeTooltip,
  },
  {
    headerName: "Current Title",
    field: "candidate.currentTitle",
    sortable: true,
    tooltipField: "candidate.currentTitle",
    getQuickFilterText: (params) => params.value,
    cellRenderer: (params) => checkNullPlaceHolder(params.value),
  },
  {
    headerName: "Status",
    field: "status",
    sortable: true,
    tooltipField: "status",
    getQuickFilterText: (params) => params.data.status.name,
    tooltipComponent: statusTooltip,
    comparator: (a, b) => stringSorting(a, b, "name"),
    cellRenderer: (params) => (
      <Flex align="center" justify="center" style={{ height: "100%" }}>
        <StatusTag status={checkNullPlaceHolder(params.data.status?.name)} />
      </Flex>
    ),
  },
  {
    headerName: "Sub Status",
    field: "subStatus",
    sortable: true,
    tooltipField: "subStatus",
    tooltipComponent: subStatusToolip,
    getQuickFilterText: (params) => params.data.subStatus?.name,

    comparator: (a, b) => stringSorting(a, b, "name"),
    cellRenderer: (params) => (
      <Flex align="center" justify="center" style={{ height: "100%" }}>
        <StatusTag
          status={checkNullPlaceHolder(params.data.subStatus?.name)}
          parentStatus={checkNullPlaceHolder(params.data.status?.name)}
        />
      </Flex>
    ),
  },
];
